import { NewsCategoryOption } from '@/entities/News/NewsCategory';

export const ALL_NEWS_CATEGORY_KEY = 'ALL';

export const ALL_NEWS_CATEGORY_OPTION: NewsCategoryOption = {
  key: ALL_NEWS_CATEGORY_KEY,
  value: 'Все категории',
};
